import { Divider, Flex, Switch, Typography } from '@banhala/ui-kit';
import { LABORATORY_ITEMS, type LaboratoryKey } from '../constants';
import { bridge } from 'shared/src/utils/bridge';

interface LaboratorySwitchProps {
  readonly laboratoryKey: LaboratoryKey;
  readonly isOn: boolean;
  readonly onChange: (value: boolean) => void;
}

export const LaboratorySwitch = ({ laboratoryKey, isOn, onChange }: LaboratorySwitchProps) => {
  const { experimentId, title, description } = LABORATORY_ITEMS[laboratoryKey];

  return (
    <Flex flex={1}>
      <Flex.Row
        gap={20}
        alignItems={'center'}
        padding={{ horizontal: 16, vertical: 20 }}
        justifyContent="space-between"
      >
        <Flex.Column gap={12} flexShrink={1}>
          <Typography type="body1" color="content_primary">
            {title}
          </Typography>

          {description && (
            <Typography type="body2" color="content_tertiary">
              {description}
            </Typography>
          )}
        </Flex.Column>

        <Switch value={isOn} onChange={(isOn) => {
          onChange(isOn);
          logToggleExperiment(isOn, experimentId);
        }} />
      </Flex.Row>

      <Divider />
    </Flex>
  );
};

const logToggleExperiment = (isOn: boolean, experimentId: string) => {
  bridge.logAnalyticsEvent({
    channel: ['firebase', 'facebook', 'ablylog'],
    name: 'TOGGLE_EXPERIMENT',
    analytics: {
      SCREEN: 'LABORATORY',
      STATUS: isOn ? '1' : '0',
      EXPERIMENT_ID: experimentId
    },
  });
};